<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */

import type { SecondaryDataInterface } from "@/types/ContentType";
import Pin from "@/components/regularComponents/UIComponents/SVG/Footer/Pin.vue";

const Link = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Link.vue")
);

const WorkingHours = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Contact/WorkingHours.vue")
);

const Contacts = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Contact/Contacts.vue")
);

const BookCall = defineAsyncComponent(() => import("./BookCall.vue"));

defineProps<{
  contentData?: SecondaryDataInterface;
}>();

const isMOdalOpen = ref(false);

const openBookingCall = () => {
  isMOdalOpen.value = true;
};
</script>

<template>
  <div class="contact-block__info c-white">
    <div class="head contact-block--mx-default">
      <h2 class="hl-1-plus">
        <span class="c-mango">{{ $t("contacts") }}</span>
      </h2>
    </div>

    <Contacts />
    <WorkingHours @openBooking="openBookingCall" />

    <div
      class="sales-offices contact-block--mx-default"
      v-if="contentData?.data?.listCount"
    >
      <div class="contact-block__info-head">{{ $t("sales offices") }}</div>
      <ul>
        <li
          class="contact-block__info-item w-max"
          v-for="(addr, index) in contentData.data?.list"
          :key="index"
        >
          <Link :label="addr?.title" :link="addr?.url" class="d-flex al-center">
            <Pin class="d-flex pin-icon icon-default" />

            <p>{{ addr?.title }}</p>
          </Link>
        </li>
      </ul>
    </div>
  </div>

  <ClientOnly>
    <Teleport to="body">
      <Transition name="fade">
        <BookCall v-if="isMOdalOpen" @close="isMOdalOpen = false" />
      </Transition>
    </Teleport>
  </ClientOnly>
</template>
